var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertOctogon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5425_6089)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9997 17.2C33.1043 17.2 33.9997 18.0954 33.9997 19.2V32C33.9997 33.1046 33.1043 34 31.9997 34C30.8952 34 29.9997 33.1046 29.9997 32V19.2C29.9997 18.0954 30.8952 17.2 31.9997 17.2ZM29.9997 44.7999C29.9997 43.6953 30.8952 42.7999 31.9997 42.7999H32.0313C33.1358 42.7999 34.0313 43.6953 34.0313 44.7999C34.0313 45.9045 33.1358 46.7999 32.0313 46.7999H31.9997C30.8952 46.7999 29.9997 45.9045 29.9997 44.7999ZM20.4089 4H43.5911L60 20.4089V43.5911L43.5911 60H20.4089L4 43.5911V20.4089L20.4089 4ZM0 18.752L18.752 0H45.248L64 18.752V45.248L45.248 64H18.752L0 45.248V18.752Z",
    fill: "#f4fdfa"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5425_6089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertOctogon);
export default __webpack_public_path__ + "static/media/alert-octogon.dc401945cd630f497ca927e044e119d3.svg";
export { ForwardRef as ReactComponent };